import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {SignaturePad} from 'angular2-signaturepad';
import {EvkFirmaDigitalModel} from '../../../models/evk-firma-digital.model';

@Component({
    selector: 'evk-firma-digital',
    templateUrl: './evk-firma-digital.component.html',
    styleUrls: ['./evk-firma-digital.component.css']
})
export class EvkFirmaDigitalComponent implements AfterViewInit {

    @Input() datosFirma: EvkFirmaDigitalModel;
    @Output() fileEventEmitter: EventEmitter<EvkFirmaDigitalModel> = new EventEmitter();

    public file: any = null;
    public fechaActual = new Date();
    public validForm = false;

    @ViewChild(SignaturePad, {static: false}) signaturePad: SignaturePad;

    public signaturePadOptions: any = {
        minWidth: 0.5,
        canvasWidth: 500,
        canvasHeight: 300
    };

    constructor() {
    }

    ngAfterViewInit(): void {
        this.signaturePad.clear();
        if (this.datosFirma.minWidth) {
            this.signaturePad.set('minWidth', this.datosFirma.minWidth);
        }
    }

    drawComplete() {
        // will be notified of szimek/signature_pad's onEnd event
        this.file = this.signaturePad.toDataURL();
    }

    drawStart() {
        this.validForm = true;
    }


    limpiarFirma() {
        this.signaturePad.clear();
        this.file = null;
        this.validForm = false;
    }

    save() {
        this.datosFirma.file = this.file;
        this.fileEventEmitter.emit(this.datosFirma);
    }
}
